import { combineReducers } from 'redux'
import { authApi } from '../api/authApi'
import { usersApi } from '../api/userApi'
import { authReducer } from '../slice/auth.slice'
import { userReducer } from '../slice/user.slice'
import { employeesApi } from '../api/employeesApi'
import { projectEmployeeLinksApi } from '../api/projectEmployeeLinksApi'
import { projectsApi } from '../api/projectsApi'
import { projectManagersApi } from '../api/projectManagersApi'
import { tmpReducer } from '../slice/tmp.slice'
import { modalReducer } from '../slice/modal.slice'
import { employeesReducer } from '../slice/employees.slice'
import { projectsReducer } from '../slice/projects.slice'
import { projectEmployeeLinksReducer } from '../slice/projectEmployeeLinks.slice'
import { projectManagersReducer } from '../slice/projectManagers.slice'
import { sequenceProjectApi } from '../api/sequenceProjectApi'
import { sequenceProjectReducer } from '../slice/sequenceProject.slice'
import { viewOptionsReducer } from '../slice/viewOptions.slice'
import { ganttReducer } from '../slice/gantt.slice'

export const rootReducer = combineReducers({
  auth: authReducer,
  [authApi.reducerPath]: authApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  user: userReducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  employees: employeesReducer,
  [projectEmployeeLinksApi.reducerPath]: projectEmployeeLinksApi.reducer,
  [projectsApi.reducerPath]: projectsApi.reducer,
  [projectManagersApi.reducerPath]: projectManagersApi.reducer,
  [sequenceProjectApi.reducerPath]: sequenceProjectApi.reducer,
  tmp: tmpReducer,
  gantt: ganttReducer,
  viewOptions: viewOptionsReducer,
  modal: modalReducer,
  projects: projectsReducer,
  projectEmployeeLinks: projectEmployeeLinksReducer,
  projectManagers: projectManagersReducer,
  sequenceProject: sequenceProjectReducer
})
